import React from "react";
import { coaching } from "../data/mock";
import { Reveal, ChapterTag } from "../lib/motion";

export const CoachingSection = () => {
  return (
    <section id="coaching" data-testid="coaching-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="10" label="Coaching & Mentoring" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-[2.9rem] max-w-4xl leading-[1.12]">
            Sometimes the business needs fixing. Sometimes the leader needs <em className=" text-brand-700">space to think</em>. Often it's both.
          </h2>
          <p className="mt-6 text-stone-600 leading-relaxed max-w-3xl">{coaching.copy}</p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {coaching.columns.map((col, i) => {
            const Icon = col.icon;
            return (
              <Reveal
                key={i}
                delay={i * 0.1}
                className="rounded-3xl bg-[#FAF7F2] border border-stone-200 p-8 text-center hover:-translate-y-1 hover:border-brand-400/50 transition-all duration-300"
                data-testid={`coaching-column-${i}`}
              >
                <div className="w-14 h-14 mx-auto rounded-full bg-[#032e2d] flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-teal-100" />
                </div>
                <h3 className="font-display font-semibold text-2xl text-stone-900">{col.title}</h3>
                <p className="mt-3 text-sm text-stone-600 leading-relaxed">{col.description}</p>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-center font-display  text-lg md:text-xl text-stone-700" data-testid="coaching-closing">
            {coaching.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
